import { connect } from 'react-redux';
import Currency from '@xanadu/ui-shared/components/Currency';


function mapStateToProps(state) {
  return {
    currency: state.getIn(['user', 'currency'])
  };
}

export default connect(mapStateToProps)(Currency);
